import { useAppDispatch } from '@/shared/hooks';

import { studyModel } from '@/entities/study';

export const useRemoveStudy = () => {
  const dispatch = useAppDispatch();

  return async (studyID: string) => {
    await dispatch(studyModel.thunks.deleteStudy({ StudyID: studyID }));
  };
};
